export const getJPGKey = (value = '', jpgMap = {}) => {
  const k = jpgMap[value]
  if (k) return k
  const key = Object.keys(jpgMap)?.find((k = '') => k.endsWith(value))
  if (key) return jpgMap[key]
  return value
}
